import React from 'react';
import { Menu } from '@headlessui/react';
import { HiChevronUpDown } from "react-icons/hi2";
import LazyLoadVideo from '../../components/LazyLoadVideo';

const effects = [
  { 
    label: 'Muscular Flex', 
    value: 'muscle', 
    video: 'https://delivery626.nyc3.cdn.digitaloceanspaces.com/video_qm3sdmm9zim5es0rg0.mp4'
  },
  { 
    label: 'Hugging', 
    value: 'hug', 
    video: 'https://delivery626.nyc3.cdn.digitaloceanspaces.com/video_w1dki2hp96rm5hr2i9a.mp4'
  }
];

const VideoEffectsSelector = ({ selectedEffect, setSelectedEffect, disabled }) => {
  const selectedEffectData = effects.find(effect => effect.value === selectedEffect);

  return (
    <Menu as="div" className="relative">
      <Menu.Button 
        className={`flex items-center gap-2 px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded-lg transition-colors ${
          disabled ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-200'
        }`}
        disabled={disabled}
      >
        {selectedEffectData ? (
          <>
            <div className="w-6 h-6 rounded-md overflow-hidden bg-gray-200">
              <video 
                src={selectedEffectData.video}
                className="w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
            <span className="font-medium">{selectedEffectData.label}</span>
          </>
        ) : (
          <span className="font-medium">Effects</span>
        )}
        <HiChevronUpDown className="w-4 h-4 text-gray-500" />
      </Menu.Button>

      <Menu.Items className="absolute bottom-full left-0 mb-2 bg-white rounded-xl shadow-xl border border-gray-200/50 p-2 focus:outline-none">
        <div className="flex gap-2 w-[400px]">
          {effects.map((effect) => (
            <Menu.Item key={effect.value}>
              {({ active }) => (
                <button
                  onClick={() => setSelectedEffect(effect.value)}
                  className={`${
                    active ? 'bg-gray-100' : ''
                  } ${
                    selectedEffect === effect.value ? 'bg-purple-50' : ''
                  } flex flex-col items-center gap-1 p-2 rounded-lg transition-colors flex-1`}
                >
                  <div className="w-32 h-32 rounded-lg overflow-hidden bg-gray-100">
                    <LazyLoadVideo 
                      dataSrc={effect.video}
                      className="w-full h-full object-cover"
                      loop
                      autoPlay
                      muted
                      playsInline
                    />
                  </div>
                  <span className="text-xs font-medium text-gray-900">{effect.label}</span>
                </button>
              )}
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Menu>
  );
};

export default VideoEffectsSelector; 